import {ITypeRadar} from "../../types";
import {FilterItemSeveral} from "../ClusterFilter/FilterItemSeveral";
import {FilterItemSingle} from "../ClusterFilter/FilterItemSingle";
import {MySelectWithCheckbox} from "../../ui/MySelectWithCheckbox";
import {MySelectWithCheckboxLifeCycle} from "../../ui/MySelectWithCheckboxLifeCycle";
import {MySelectWithCheckboxInfluenceZone} from "../../ui/MySelectWithCheckboxInfluenceZone";
import {MySelectWithCheckboxObligation} from "../../ui/MySelectWithCheckboxObligation";
import {MySelectWithCheckboxParticipationFormat} from "../../ui/MySelectWithCheckboxParticipationFormat";
import {MySelect} from "../../ui/MySelect";
import {Container, IconContainer} from "../ClusterFilter/styles";
import {FILTERS_ITEMS} from "../ClusterFilter/data";
import {IEsgFilters} from "../../pages/Esg/EsgDashboard.type";
import IconEyeClose from "../../assets/icons/filters/eye-close.svg";
import IconEyeOpen from "../../assets/icons/filters/IconEye.svg";
import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "../../pages/Fintech/FintechDashboard.type";
import {IdashboardFilters} from "../../pages/Dashboard/Dashboard.type";
import {
  IAuthority,
  IStateInitiativeFilters,
} from "../../pages/StateInitiative/StateInitiative.type";
import {CustomSwitch} from "../../ui/CustomSwitch";
import {useEffect, useRef, useState} from "react";
import {FilterItemSeveralMaturity} from "../ClusterFilter/FilterItemSeveralMaturity";

interface IPropsPanelFilters {
  isVisible: boolean;
  onClose: () => void;
  typeRadar: ITypeRadar;
  filters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  onFilterChange: <T>(filter?: string, value?: T, isReset?: boolean) => void;
  filterWeakSignals?: IFintechWeakSignalsFilters;
  authorities?: IAuthority[];
  setIsShowAllLabels: React.Dispatch<React.SetStateAction<boolean>>;
  isShowAllLabels: boolean;
  isLogin?: boolean;
  role?: string | null;

  isNationalProjects?: boolean;
  setIsNationalProjects?: React.Dispatch<React.SetStateAction<boolean>>;

  isBenefitsSubsidies?: boolean;
  setIsBenefitsSubsidies?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SidebarFiltersPanel: React.FC<IPropsPanelFilters> = ({
  isVisible,
  onClose,
  typeRadar,
  filters,
  onFilterChange,
  filterWeakSignals,
  authorities,
  setIsShowAllLabels,
  isShowAllLabels,
  isLogin,
  role,

  isNationalProjects,
  setIsNationalProjects,

  isBenefitsSubsidies,
  setIsBenefitsSubsidies,
}) => {
  const [isResetFilters, setIsResetFilters] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const filtersItems = FILTERS_ITEMS.get(typeRadar);
  const [positionUp, setPositionUp] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  let typedFilters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;

  useEffect(() => {
    if (!isVisible) {
      setPositionUp(false);
      setIsReady(false);
      return;
    }

    if (ref.current) {
      requestAnimationFrame(() => {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          const spaceBelow = window.innerHeight - rect.top;
          if (rect.height > spaceBelow) {
            setPositionUp(true);
          } else {
            setPositionUp(false);
          }
          setIsReady(true);
        }
      });
    }
  }, [isVisible]);

  switch (typeRadar) {
    case "fintech":
      typedFilters = filters as IFintechFilters;
      break;
    case "map":
      typedFilters = filters as unknown as IdashboardFilters;
      break;
    case "esg":
      typedFilters = filters as IEsgFilters;
      break;
    case "stateInitiative":
      typedFilters = filters as IStateInitiativeFilters;
      break;
    default:
      typedFilters = filters as IFintechFilters;
  }
  return (
    <>
      {isVisible && (
        <Container ref={ref} positionUp={positionUp} isReady={isReady}>
          {filtersItems &&
            filtersItems.map((item, index) => {
              if (typeRadar === "stateInitiative" && item.id === "gpb") {
                return null;
              }

              // Скрываем фильтры в зависимости от роли для stateInitiative
              if (typeRadar === "stateInitiative") {
                // Фильтры только для роли "internal"
                const internalOnlyFilters = [
                  "lobbying_capability",
                  "participation_formats",
                ];

                // Фильтры для авторизованных пользователей (test и internal)
                const authOnlyFilters = [
                  "influence_zone_tier",
                  "obligation_level",
                  "business_impact",
                ];

                if (
                  internalOnlyFilters.includes(item.id) &&
                  role !== "internal"
                ) {
                  return null;
                }

                if (authOnlyFilters.includes(item.id) && !isLogin) {
                  return null;
                }
              }

              if (item.type === "several") {
                return (
                  <FilterItemSeveral
                    key={`market_volume-${item.id}`}
                    item={item}
                    typeRadar={typeRadar}
                    filters={filters}
                    onFilterChange={onFilterChange}
                    typedFilters={typedFilters}
                    filterWeakSignals={filterWeakSignals}
                    isResetFilters={isResetFilters}
                    setIsResetFilters={setIsResetFilters}
                  />
                );
              } else if (item.type === "single") {
                // const isActive =  ;
                return (
                  <FilterItemSingle
                    key={`market_volume2-${item.id}`}
                    item={item}
                    typeRadar={typeRadar}
                    // isActive={isActive}
                    filters={filters}
                    onFilterChange={onFilterChange}
                    typedFilters={typedFilters}
                    filterWeakSignals={filterWeakSignals}
                  />
                );
              } else if (item.type === "selectCheckbox") {
                if (item.id === "live_circle_tier") {
                  return (
                    <MySelectWithCheckboxLifeCycle
                      key={`market_volume3-${item.id}`}
                      onFilterChange={onFilterChange}
                      title={item.title}
                      typeRadar={typeRadar}
                      isResetFilters={isResetFilters}
                      setIsResetFilters={setIsResetFilters}
                      currentValues={
                        (filters as IStateInitiativeFilters).lifecycle_stage
                          .value
                      }
                    />
                  );
                } else if (item.id === "influence_zone_tier") {
                  return (
                    <MySelectWithCheckboxInfluenceZone
                      key={`market_volume3-${item.id}`}
                      onFilterChange={onFilterChange}
                      title={item.title}
                      typeRadar={typeRadar}
                      isResetFilters={isResetFilters}
                      setIsResetFilters={setIsResetFilters}
                    />
                  );
                } else if (item.id === "obligation_level") {
                  return (
                    <MySelectWithCheckboxObligation
                      key={`market_volume3-${item.id}`}
                      onFilterChange={onFilterChange}
                      title={item.title}
                      typeRadar={typeRadar}
                      isResetFilters={isResetFilters}
                      setIsResetFilters={setIsResetFilters}
                    />
                  );
                } else if (item.id === "participation_formats") {
                  return (
                    <MySelectWithCheckboxParticipationFormat
                      key={`market_volume3-${item.id}`}
                      onFilterChange={onFilterChange}
                      title={item.title}
                      typeRadar={typeRadar}
                      isResetFilters={isResetFilters}
                      setIsResetFilters={setIsResetFilters}
                    />
                  );
                } else {
                  return (
                    <MySelectWithCheckbox
                      key={`market_volume3-${item.id}`}
                      authorities={authorities}
                      onFilterChange={onFilterChange}
                      title={item.title}
                      typeRadar={typeRadar}
                      isResetFilters={isResetFilters}
                      setIsResetFilters={setIsResetFilters}
                    />
                  );
                }
              } else if (item.type === "select") {
                return (
                  <MySelect
                    key={`market_volume4-${item.id}`}
                    onFilterChange={onFilterChange}
                    title={item.title}
                    idSelect={item.id}
                    selectOptions={item.selectOptions}
                    typeRadar={typeRadar}
                    filters={
                      typeRadar === "esg"
                        ? (filters as IEsgFilters)
                        : (filters as IStateInitiativeFilters)
                    }
                    isResetFilters={isResetFilters}
                    setIsResetFilters={setIsResetFilters}
                  />
                );
              } else if (item.type === "severalMaturity") {
                return (
                  <FilterItemSeveralMaturity
                    key={`several_maturity-${item.id}`}
                    item={item}
                    typeRadar={typeRadar}
                    filters={filters}
                    onFilterChange={onFilterChange}
                    typedFilters={typedFilters}
                    filterWeakSignals={filterWeakSignals}
                    isResetFilters={isResetFilters}
                    setIsResetFilters={setIsResetFilters}
                  />
                );
              }
              return null;
            })}
          {typeRadar === "map" && (
            <IconContainer>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    gap: 10,
                  }}
                >
                  <CustomSwitch
                    checked={isNationalProjects}
                    onChange={() => {
                      if (setIsNationalProjects)
                        setIsNationalProjects(!isNationalProjects);
                    }}
                  />{" "}
                  Нац. проекты
                </div>
                <img
                  src={isNationalProjects ? IconEyeOpen : IconEyeClose}
                  alt=""
                />
              </div>
            </IconContainer>
          )}
          {typeRadar === "stateInitiative" &&
            isLogin &&
            role === "internal" && (
              <IconContainer>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: 10,
                    }}
                  >
                    <CustomSwitch
                      checked={isBenefitsSubsidies}
                      onChange={() => {
                        if (setIsBenefitsSubsidies)
                          setIsBenefitsSubsidies(!isBenefitsSubsidies);
                      }}
                    />{" "}
                    Возможные льготы и субсидии
                  </div>
                </div>
              </IconContainer>
            )}
          <IconContainer>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: 10,
                }}
              >
                <CustomSwitch
                  checked={isShowAllLabels}
                  onChange={() => setIsShowAllLabels(!isShowAllLabels)}
                />{" "}
                Названия{" "}
                {typeRadar === "stateInitiative" ? "инициатив" : "кластеров"}
              </div>
              <img src={isShowAllLabels ? IconEyeOpen : IconEyeClose} alt="" />
            </div>
          </IconContainer>

          <IconContainer
            isWidthAuto
            onClick={() => {
              onFilterChange(undefined, undefined, true);
              setIsResetFilters(true);
            }}
          >
            Очистить фильтры
          </IconContainer>
        </Container>
      )}
    </>
  );
};
